import React from 'react';
import { Quote } from 'lucide-react';
import { Card } from './ui/Card';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Elowen',
    role: 'Parent',
    quote: "Finally, a place where I don't have to worry about what my kids are clicking on. Total peace of mind!",
    color: 'bg-candy-pink/10',
    avatarColor: 'bg-candy-pink'
  }, {
    name: 'Thiago',
    role: 'Kid, Age 11',
    quote: 'Pixel Pals is awesome! I met new friends and we play together every weekend.',
    color: 'bg-candy-teal/10',
    avatarColor: 'bg-candy-teal'
  }, {
    name: 'Seren',
    role: 'Parent',
    quote: "Glow Trail helps me manage screen time without the arguments. It's a game-changer for our family.",
    color: 'bg-candy-yellow/10',
    avatarColor: 'bg-candy-yellow'
  }, {
    name: 'Caspian',
    role: 'Kid, Age 9',
    quote: 'Lumino Quest is my favorite game ever! I love earning badges in Bloom Boost too.',
    color: 'bg-candy-purple/10',
    avatarColor: 'bg-candy-purple'
  }];
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-177">
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-178">
        <div className="text-center mb-16" data-id="element-179">
          <h2 className="text-4xl md:text-5xl font-bold text-candy-dark mb-4" data-id="element-180">
            What Families Are Saying
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-181">
          {testimonials.map((t, index) => <Card key={index} className={`p-6 border-none ${t.color}`} hoverEffect={true} data-id="element-182">
              <Quote className="w-8 h-8 text-candy-dark/20 mb-4" data-id="element-183" />
              <p className="text-gray-700 font-medium mb-6 italic leading-relaxed" data-id="element-184">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-185">
                <div className={`w-10 h-10 rounded-full ${t.avatarColor} flex items-center justify-center text-white font-bold text-lg`} data-id="element-186">
                  {t.name[0]}
                </div>
                <div data-id="element-187">
                  <div className="font-bold text-candy-dark" data-id="element-188">{t.name}</div>
                  <div className="text-xs text-gray-500 uppercase tracking-wider" data-id="element-189">
                    {t.role}
                  </div>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}